import cookie, {CookieAttributes} from 'js-cookie';
import {COOKIES} from './cookies';

export const setToCookie = (cookieName: COOKIES, value, attributes: CookieAttributes = {}) => {
  cookie.set(cookieName, value, attributes);
};
